import React from 'react';
import { themed } from '@heathmont/moon-utils';
import styled from 'styled-components';
const Svg = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 20 12", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.377 0L10 7.014 2.624 0 0 2.5 10 12l10-9.502z", fill: "currentColor", fillRule: "evenodd" })));
const IconChevronDown = styled(Svg)(({ backgroundColor, circleColor, color, theme }) => [
    {
        verticalAlign: 'middle',
    },
    backgroundColor && {
        backgroundColor: themed('color', backgroundColor)(theme),
        padding: backgroundColor ? '0.25em' : 0,
        overflow: 'visible',
        borderRadius: '50%',
    },
    color && {
        color: themed('color', color)(theme),
    },
    circleColor && {
        circle: {
            fill: themed('color', circleColor)(theme),
        },
    },
]);
export default IconChevronDown;
